import React from "react";
import { Area, CartesianGrid, AreaChart } from "recharts";
import "./styles.scss";

type Props = {
  data: { name: string; amount: number }[];
  gradientLineColor: React.ReactElement<SVGElement>;
};

const MinimalAreaChart = ({ data, gradientLineColor }: Props) => {
  return (
    // D-10: charts keep their natural (LTR) orientation in both languages.
    <div dir="ltr" style={{ display: "inline-block" }}>
      <AreaChart width={106} height={45} data={data}>
        <defs>
          <linearGradient id="areaColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#e6e8ef" stopOpacity={0.8} />
            <stop offset="35%" stopColor="#e6e8ef" stopOpacity={0.6} />
            <stop offset="95%" stopColor="#e6e8ef" stopOpacity={0} />
          </linearGradient>
          {gradientLineColor}
        </defs>
        <CartesianGrid vertical={false} horizontal={false} />
        <Area
          type="natural"
          dataKey="amount"
          stroke={`url(#${gradientLineColor?.props?.id})`}
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#areaColor)"
        />
      </AreaChart>
    </div>
  );
};

export default MinimalAreaChart;
